import { Box } from "@mui/material";
import { ThanksToYouJoinCard } from "Components/Affiliate/ThanksToYou/ThanksToYouJoinCard";
import { ThanksToYouWithdrawnCard } from "Components/Affiliate/ThanksToYou/ThanksToYouWithdrawnCard";
import { ProgramParticipationState } from "Infrastructure/Api/Api";
import type { FC } from "react";

/** The states that keep a Customer out of Díky Tobě: a refusal (can join) and the confirmed opt-out (final). */
export type NotParticipatingState =
  | ProgramParticipationState.OptedOut
  | ProgramParticipationState.Withdrawn;

const CARD_BY_STATE: Record<NotParticipatingState, FC> = {
  [ProgramParticipationState.OptedOut]: ThanksToYouJoinCard,
  [ProgramParticipationState.Withdrawn]: ThanksToYouWithdrawnCard,
};

/** The lookup is the single source of truth for who is out — NotAsked and OptedIn take part. */
export const isNotParticipating = (
  state: ProgramParticipationState,
): state is NotParticipatingState => state in CARD_BY_STATE;

type Props = {
  state: NotParticipatingState;
};

/** What a Customer outside Díky Tobě sees instead of the program content (ZS-1623). */
export const ThanksToYouNotParticipatingCard = ({ state }: Props) => {
  const Card = CARD_BY_STATE[state];

  return (
    <Box display="flex" justifyContent="center">
      <Box width="100%" maxWidth="600px">
        <Card />
      </Box>
    </Box>
  );
};
